/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ward: NonNullable<unknown>, names: NonNullable<unknown> }} Carrier_Legacy_InfoInputs */

const vi_carrier_legacy_info = /** @type {(inputs: Carrier_Legacy_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ward} gồm ${i?.names} trước sáp nhập. Viettel Post vẫn in tem theo tên cũ.`)
};

/**

* @param {Carrier_Legacy_InfoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_info = /** @type {((inputs: Carrier_Legacy_InfoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_InfoInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_info(inputs)
});